import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Document } from 'src/app/models/device-documentation/device-documentation.model';
import { DeviceRepositoryService } from 'src/app/models/device/device-repository.service';
import { environment } from 'src/environments/environment';
import { RestDeviceDocumentationService } from '../rest/device-documentation/rest-device-documentation.service';
import { PageService } from './page.service';
import { TranslateFirebaseService } from './translate-firebase.service';

@Injectable()
export class DocumentationService {

  private _document : Document;

  private _documentType: string = '';
  private _documentDescription: string = '';

  constructor(private deviceRepo: DeviceRepositoryService,
    private documentationRest: RestDeviceDocumentationService,
    private pageService: PageService,
    private translate : TranslateFirebaseService) { }

  get type(): string {
    return this._documentType;
  }

  set type(value: string) {
    this._documentType = value;
  }

  get description(): string {
    return this._documentDescription;
  }

  set description(value: string) {
    this._documentDescription = value;
  }

  get document(): Document {
    if (this._document) return this._document;
    else return JSON.parse(sessionStorage.getItem(environment.storage.upsSelectedDocument));
  }

  set document(doc : Document) {
    this._document = doc;
    sessionStorage.setItem(environment.storage.upsSelectedDocument, JSON.stringify(doc));
  }

  downloadPdf() : Observable<any> {
    return this.deviceRepo.downloadDocument(this.document.id);
  }

  uploadDocument(value: FormData) {
    return this.documentationRest.uploadDocument(value);
  }

  updateDocument(documentId: number, document: FormData) {
    return this.documentationRest.updateDocument(documentId, document);
  }

  changeDocumentStatus(documentId: number, status: number) {
    this.documentationRest.changeDocumentStatus(documentId, status)
      .subscribe((result) => {
        this.pageService.openSnackBar(this.translate.getTranslation('backoffice_general_edit_success'), 'Ok');
      }, error => {
        this.pageService.openErrorSnackBar(this.translate.getTranslation('backoffice_general_edit_failed'), 'Ok');
        console.log(error);
      })
  }

  deleteDocument(articleId: number, documentId: number): Observable<any> {
    return this.documentationRest.deleteDocument(articleId, documentId);
  }
}
